import { render, staticRenderFns } from "./LightSpeedVideoGroup.vue?vue&type=template&id=5fdb8ea4&"
import script from "./LightSpeedVideoGroup.vue?vue&type=script&lang=js&"
export * from "./LightSpeedVideoGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports